import { Card, Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import dayjs from "dayjs";
import useGetVehicleDailyFormWorkOrders from "hooks/fleet/useGetVehicleDailyFormWorkOrders";
import { useState } from "react";
import { Link } from "react-router-dom";

interface VehicleMaintenanceHistorySectionProps {
  vehicleId: string;
}

export default function VehicleMaintenanceHistorySection({
  vehicleId,
}: VehicleMaintenanceHistorySectionProps) {
  const [page, setPage] = useState(1);
  const { data: rows, paginatorInfo, fetchMore, loading } = useGetVehicleDailyFormWorkOrders({
    variables: {
      first: 20,
      page,
      vehicleId,
    },
  });

  const handleLoadMore = async () => {
    const nextPage = page + 1;
    await fetchMore({ page: nextPage });
    setPage(nextPage);
  };

  return (
    <Card>
      <MDBox p={3}>
        <MDTypography variant="h6" fontWeight="medium" mb={2}>
          Maintenance History
        </MDTypography>

        {rows.length === 0 ? (
          <MDTypography variant="body2" color="text">
            No shop tasks found for this vehicle.
          </MDTypography>
        ) : (
          <>
            <Grid container spacing={2}>
              {rows.map((row: any) => (
                <Grid item xs={12} key={row.id}>
                  <MDBox px={2} py={1.5} border="1px solid #e0e0e0" borderRadius="8px">
                    <MDTypography
                      variant="button"
                      fontWeight="medium"
                      component={Link}
                      to={`/fleet/work-orders/${row.id}/edit`}
                      sx={{
                        cursor: "pointer",
                        color: "inherit",
                        textDecoration: "none",
                        "&:hover": {
                          textDecoration: "underline",
                        },
                      }}
                    >
                      {row.issueName}
                    </MDTypography>
                    <MDTypography variant="caption" display="block" color="text">
                      Status: {row.status || "N/A"} | Created:{" "}
                      {row.createdAt ? dayjs(row.createdAt).format("MM/DD/YYYY h:mm A") : "N/A"}
                    </MDTypography>
                    <MDTypography variant="caption" display="block" color="text">
                      Due: {row.neededCompletionDate ? dayjs(row.neededCompletionDate).format("MM/DD/YYYY") : "N/A"}{" "}
                      | Completed: {row.completedAt ? dayjs(row.completedAt).format("MM/DD/YYYY h:mm A") : "N/A"}
                    </MDTypography>
                    <MDTypography variant="caption" display="block" color="text">
                      Meter: {row.currentMeterReading ?? "N/A"} | Assigned To: {row.assignedTo?.name || "Unassigned"}
                    </MDTypography>
                  </MDBox>
                </Grid>
              ))}
            </Grid>

            {paginatorInfo?.hasMorePages && (
              <MDBox mt={2} display="flex" justifyContent="center">
                <MDButton color="info" variant="outlined" onClick={handleLoadMore} disabled={loading}>
                  Load More
                </MDButton>
              </MDBox>
            )}
          </>
        )}
      </MDBox>
    </Card>
  );
}
